module.exports = __webpack_public_path__ + "static/media/Pinterest.7415acd4.png";